export function convertMS(ms) {
  var d, h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = pad(s % 60);
  h = Math.floor(m / 60);
  m = pad(m % 60);
  d = Math.floor(h / 24);
  h = pad(h % 24);
  return { d: d, h: h, m: m, s: s };
}

function pad(number) {
  return (number < 10 ? "0" : "") + number;
}

export function formatTimeRemaining(ms) {
  const oneDay = 24 * 60 * 60;
  const oneWeek = 7 * oneDay;
  const oneMonth = 30 * oneDay; // Approximate month

  if (ms >= oneMonth) {
    const months = Math.floor(ms / oneMonth);
    return { m: months };
  } else if (ms >= oneWeek) {
    const weeks = Math.floor(ms / oneWeek);
    return { w: weeks };
  } else if (ms >= oneDay) {
    let days = Math.floor(ms / oneDay);
    return { d: days };
  } else {
    return { d: 1 };
  }
}
